import React, { useEffect } from 'react';
import { useLocation, useHistory } from "react-router-dom";


const NotFound = (props) => {
    const history = useHistory();
    const location = useLocation();
    let pathname = location.pathname;

    const redirectToPath = () => {
        if (pathname === "/app/company") {
            checkPermissionAndRedirect();
        } else {
            let pathArray = window.location.pathname.split('/');
            if (pathArray[2] === "company") {
                if (pathArray[3] === "pipelines") {
                    history.push("/app/company/pipelines");
                } else if (pathArray[3] === "reviews") {
                    history.push("/app/company/reviews");
                } else if (pathArray[3] === "interviews") {
                    history.push("/app/company/interviews");
                } else if (pathArray[3] === "scheduled-interviews") {
                    history.push("/app/company/scheduled-interviews");
                } else if (pathArray[3] === "pending-interviews") {
                    history.push("/app/company/pending-interviews");
                } else if (pathArray[3] === "users") {
                    history.push("/app/company/users");
                } else if (pathArray[3] === "settings") {
                    history.push("/app/company/settings");
                } else if (pathArray[3] === "billing") {
                    history.push("/app/company/billing");
                } else if (pathArray[3] === "analytics") {
                    history.push("/app/company/analytics");
                } else if (pathArray[3] === "offer-handling") {
                    history.push("/app/company/offer-handling");
                } else if (pathArray[3] === "approvals") {
                    history.push("/app/company/approvals");
                }
                else if (pathArray[3] === "pending-onboarding") {
                    history.push("/app/company/pending-onboarding");
                }else{
                    checkPermissionAndRedirect();
                }
            }
        }
    }

    const checkPermissionAndRedirect = () =>{
        if ((props.permissions.access_levels.hiring_pipeline.is_enabled === true || (props.permissions.user_role === 0 && JSON.parse(localStorage.getItem('paymentStatus')) === false))) {
            history.push("/app/company/pipelines");
        }
         else if (props.permissions.access_levels.cv_review.is_enabled === true) {
            history.push("/app/company/reviews");
        } else if (props.permissions.access_levels.interviews.is_enabled === true) {
            history.push("/app/company/interviews");
        } else if (props.permissions.access_levels.manage_users.is_enabled === true) {
            history.push("/app/company/users");
        } else if (props.permissions.access_levels.company_settings.is_enabled === true) {
            history.push("/app/company/settings");
        } else if (props.permissions.access_levels.billing.is_enabled === true) {
            history.push("/app/company/billing");
        } else if (props.permissions.access_levels.analytics.is_enabled === true) {
            history.push("/app/company/analytics");
        } else if (props.permissions.access_levels.offer_handling.is_enabled === true) {
            history.push("/app/company/offer-handling");
        } else if (props.permissions.access_levels.onboarding.is_enabled === true) {
            history.push("/app/company/pending-onboarding");
        }
        
    }

    useEffect(() => {
        redirectToPath();
    }, []);

    return (
        <div>
        </div>
    )
}

export default NotFound;
